import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { Card, Container, Tabs, Tab, Button, Col, Row } from "react-bootstrap";
import SearchFilter from "../../../components/SearchFilter";
import Table from "../../../components/Table";
import ConfirmModal from "../../../components/ConfirmModal";
import ButtonLink from "../../../components/ButtonLink";
export default function CheckeQuipment() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({ check: [], show: [] });
  const [searchValue, setSearchValue] = useState({ check: [], show: [] });
  const { websiteName, setWebsiteName } = useWebsiteName();
  const searchInput = {
    check_head: [
      {
        name: "Bill_of_hd_no",
        name: "เลขที่ใบขอเบิก",
        value: null
      }
    ],
    check_body: [
      {
        name: "Tech_mas_name",
        name: "ช่างผู้ปฏิบัติงาน",
        classNames: { label: "mb-3" },
        value: null
      },
      {
        name: "Sec_team ",
        name: "ทีมย่อย",
        classNames: { label: "mb-3" },
        disabled: true,
        type: "text",
        value: null
      },
      {
        name: "Sup_team",
        name: "ชื่อทีม/หัวหน้าช่าง",
        classNames: { label: "mb-3" },
        disabled: true,
        type: "text",
        value: null
      },
      {
        name: "Jobtype_name",
        name: "ประเภทงาน",
        classNames: { label: "mb-3" },
        value: null
      },

      {
        name: "Item_rev_doc_date",
        name: "วันที่ตรวจรับอุปกรณ์/อะไหล่",
        classNames: { label: "mb-3" },
        type: "date",
        disabled: true,
        size: 2,
        value: null
      },
      {
        name: "Item_rev_doc_time",
        name: "เวลา",
        classNames: { label: "mb-3" },
        disabled: true,
        type: "time",
        size: 1,
        value: null
      },
      {
        name: "Item_rev_doc_no",
        name: "เลขที่รับงานทีมช่าง",
        classNames: { label: "mb-3" },
        disabled: true,
        type: "text",
        value: null
      }
    ]
  };
  const columns = {
    check: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "ประเภทงาน",
        selector: (row) => row.Jobtype_name,
        sortable: true
      },
      {
        name: "เลขที่ใบขอเบิก",
        selector: (row) => row.Bill_of_hd_no,
        sortable: true
      },
      ,
      {
        name: "รหัสอุปกรณ์/อะไหล่",
        selector: (row) => row.Child_item_code,
        sortable: true
      },
      ,
      {
        name: "Tag-ชุดกรอง",
        selector: (row) => row.Item_model,
        sortable: true
      },
      ,
      {
        name: "บาร์โคด",
        selector: (row) => row.Item_barcode,
        sortable: true
      },
      ,
      {
        name: "รายละเอียดอุปกรณ์/อะไหล่",
        selector: (row) => row.Item_name,
        sortable: true
      },
      ,
      {
        name: "คลัง",
        selector: (row) => row.wh_code,
        sortable: true
      },
      {
        name: "จำนวน",
        selector: (row) => row.Item_req_qty,
        sortable: true
      },
      ,
      {
        name: "จำนวนที่รับ",
        selector: (row) => row.Item_rev_qty,
        sortable: true
      },
      ,
      {
        name: "หน่วยนับ",
        selector: (row) => row.Unit_uom,
        sortable: true
      },
      ,
      {
        name: "หมายเหตุ",
        selector: (row) => row.Remark,
        sortable: true
      },
      ,
      {
        name: "Accept",
        selector: (row) => row.accept,
        sortable: true
      },
      ,
      {
        name: "Use",
        selector: (row) => row.Use_flag,
        sortable: true
      }
    ]
  };
  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    dataCallback && console.log(dataCallback);
  };
  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1000);
  }, []);
  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta
          name="description"
          content="Check and receive equipment/spare parts Page"
        />
      </Helmet>
      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state || "check"}
          onSelect={(k) => setWebsiteName("ตรวจรับอุปกรณ์/อะไหล่")}
        >
          <Tab eventKey="check" title="ตรวจรับอุปกรณ์/อะไหล่">
            <Card className="mb-3 p-4 border-0">
              <Card.Body>
                <SearchFilter
                  data={data.check}
                  inputField={searchInput.check_head}
                  fieldClassName={{
                    inputRow: "justify-content-start align-items-center",
                    actionButton: "w-auto py-2"
                  }}
                  searchCallback={(search) =>
                    setSearchValue((prev) => ({
                      ...prev,
                      check: search
                    }))
                  }
                />
              </Card.Body>
            </Card>

            <Card className="mb-3 p-4 border-0">
              <Card.Body>
                <SearchFilter
                  data={data.check}
                  inputField={searchInput.check_body}
                  fieldClassName={{
                    inputRow: "justify-content-start align-items-center"
                  }}
                  searchCallback={(search) =>
                    setSearchValue((prev) => ({
                      ...prev,
                      check: search
                    }))
                  }
                />
              </Card.Body>
            </Card>

            <Card className="mb-3 p-4 border-0">
              <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
                <Card.Title className="mb-0 fs-2">
                  รายละเอียดอุปกรณ์/อะไหล่ที่ใช้
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <Table
                  data={data.check}
                  column={columns.check}
                  pending={loading}
                  searchFilter={searchValue.check}
                  pagination
                />
              </Card.Body>
            </Card>
            <Card className="mb-3 p-4 border-0">
              <Row className="mt-3 text-center">
                <Col className="mt-3">
                  <ButtonLink
                    linkTo=""
                    buttonName="แสดงใบขอเบิก"
                    buttonClass="me-2 py-2 px-5 rounded-pill"
                    iconClass="me-2 mb-1"
                  />

                  <ButtonLink
                    linkTo=""
                    buttonName="แสดงใบรับอุปกรณ์/อะไหล่"
                    buttonClass="me-2 py-2 px-5 rounded-pill"
                    iconClass="me-2 mb-1"
                  />
                </Col>
              </Row>
            </Card>
            <Card className="mb-3 p-4 border-0">
              <Row className=" text-center">
                <Col className="mt-3">
                  <Button
                    type="submit"
                    variant="success"
                    className="me-2 px-5 py-2 text-dark rounded-pill"
                    onClick={() => setShowModal(!showModal)}
                  >
                    บันทึกข้อมูล
                  </Button>
                  <ConfirmModal
                    show={showModal}
                    data={data}
                    content={"save"}
                    onSubmitCallback={handleSubmit}
                  />

                  <Button
                    variant="outline-success"
                    className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                    onClick={() =>
                      navigate("/service_work/planning", {
                        state: "agency"
                      })
                    }
                  >
                    ยกเลิก
                  </Button>
                </Col>
              </Row>
            </Card>
          </Tab>

          <Tab eventKey="show" title="แสดงใบรับอุปกรณ์/อะไหล่"></Tab>
        </Tabs>
      </Container>
    </>
  );
}
